 
   import React from 'react'
   
   function Payment() {
     return (
        <>
        <h1>payment page</h1>
{/*          
    <div id="header">
        <img src="./payment/Screenshot (643).png" alt=""/>
    </div>
    <div><h1>Payment Gateway</h1></div>
    <div id="main">
        <div id="option">

<h2><i className='fas fa-wallet'></i>Wallet</h2>
<h2><img src="https://img.icons8.com/fluency/40/000000/bhim.png"/>UPI</h2>
<h2><i style="font-size:24px" className="fa">&#xf09d;</i>Cards</h2>
<h2><i style="font-size:24px" className="fa">&#xf19c;</i>Net Banking</h2>
<h2><svg xmlns="http://www.w3.org/2000/svg" width="29" height="26" fill="currentColor" className="bi bi-cash" viewBox="0 0 18 11">
    <path d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/>
    <path d="M0 4a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4zm3 0a2 2 0 0 1-2 2v4a2 2 0 0 1 2 2h10a2 2 0 0 1 2-2V6a2 2 0 0 1-2-2H3z"/>
  </svg>Pay On Delivery</h2>

        </div>

        <div id="card">
            <h3>Credit & Debit Cards</h3>
            <p>Add new cards for payment</p>
           <p> Card Number</p>
           <input type="number" placeholder="Enter Card Number"/>
           <p>Expiry Date</p>
           <input type="date"/>
           <p>CVV</p>
           <input type="number" placeholder="Enter CVV"/>
           
           
           <p>Your card details will be saved securely for future transactions, based on the industry standards. <u>Terms & condition</u></p>

           <button id="btn">Make Payment</button>
           
        </div>

        <div id="summary">
            <div id="summary1"><h2>Payment Summary</h2></div>
            <div id="miniBox">
                <div id="mini1">
                    <p>Amount</p>
                    <p>Card Offer</p>
                </div>
                <div id="mini2">
                    <p>0</p>
                    <p>-1500</p>
                </div>
                
            </div>
                <hr>
           <div id="total">

            <p>Total Amount</p>
            <p>0</p>

           </div>
           </hr>
            
        </div>
    </div>

    <div id="last"> <img src="https://content1.geekbuying.com/V1.4/en/images/shopcart_footicon.png" alt=""/></div> */}
        </>
     )
   }
   
   export default Payment 
     
    
 
       
 
 
 
 
 